import { useMemo } from 'react';

import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { getFlatElementList } from './collinsMpcUtilities';
import NestedElement from './NestedElement';
import TopLevelElement from './TopLevelElement';

interface Props {
  workOrder: any;
}

const ElementsSection = ({ workOrder }: Props) => {
  const elements = getFlatElementList(workOrder);

  const mediaDictionary = useMemo(() => {
    if (isNilOrEmpty(workOrder)) {
      return {};
    }

    return workOrder?.media?.media.reduce((acc, item) => {
      const key = item.subjectId;

      return {
        ...acc,
        [key]: acc[key] ? [...acc[key], item] : [item],
      };
    }, {});
  }, [workOrder]);

  return (
    <>
      {elements.map(element => {
        return element?.topLevel ? (
          <TopLevelElement key={element?.id} element={element} />
        ) : (
          <NestedElement
            key={element?.id}
            element={element}
            mediaDictionary={mediaDictionary}
          />
        );
      })}
    </>
  );
};

export default ElementsSection;
